import React, { useRef } from 'react';

export default function ThoughtNote({ thought, userId, onDrag, onClick }) {
    const start = useRef({ x: 0, y: 0, moved: false });
    const isOwner = thought.user_id === userId;

    return (
        <div
            className="note-card thought-note touch-none absolute p-2 rounded text-sm max-w-[160px] break-words"
            style={{
                top: thought.y,
                left: thought.x,
                backgroundColor: thought.color,
                cursor: isOwner ? 'move' : 'default',
                userSelect: 'none',
            }}
            onPointerDown={(e) => {
                start.current = { x: e.clientX, y: e.clientY, moved: false };
                if (isOwner && onDrag) onDrag(e, thought);
            }}
            onPointerMove={(e) => {
                if (Math.hypot(e.clientX - start.current.x, e.clientY - start.current.y) > 4) {
                    start.current.moved = true;
                }
            }}
            onClick={(e) => {
                e.stopPropagation();
                if (!start.current.moved && onClick) onClick(e, thought);
            }}
        >
            <div className="whitespace-pre-wrap break-words">{thought.content}</div>
            {thought.display_name && thought.display_name.trim() !== '' && (
                <div className="mt-1 text-[11px] italic text-black/40">— {thought.display_name}</div>
            )}
        </div>
    );
}